/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// Service having to do with serving up the default avatar images for a Unit
angular.module('bulbApp.avatarImageModule')
  .service('BulbAvatarService', function bulbAvatarService() {

    /*
    * Get the resource with the path of the default avatar image for a Unit. If it is a UserUnit or a normal GroupUnit
    * we return the default avatar image. If it is a MacMillan GroupUnit, we go ahead and return the default avatar
    * for the corresponding book.
    */
    this.getDefaultAvatarImage = function getDefaultAvatarImage(viewType, unit) {
      if (viewType === 'group') {
        if ((unit?.features?.macMillan)) {
          const { book } = unit.features.macMillan;
          if (book === 'NEXT_STATION_2') {
            return 'resources/images/next_station_2_circle.svg';
          } if (book === 'NEXT_STATION_3') {
            return 'resources/images/next_station_3_circle.svg';
          } if (book === 'NEXT_STATION_4') {
            return 'resources/images/next_station_4_circle.svg';
          }
        }
        // If for some reason we can't find the correct book, just return the default group avatar
        return 'USE_DEFAULT_GROUP_AVATAR';
      }
      // If for some reason we can't find the correct book, just return the default group avatar
      return 'USE_DEFAULT_USER_AVATAR';
    };
  });
